module.exports = __webpack_public_path__ + "img/tz.1aa550a9.svg";